import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
export function SignatureConceptsPage() {
  const concepts = [{
    name: 'The Estate Green',
    mood: 'Private, Expansive, Professional',
    setting: 'Luxury Residential',
    color: 'from-[#0F2419] to-[#2D5A3D]'
  }, {
    name: 'The Social Green',
    mood: 'Entertaining, Relaxed, Integrated',
    setting: 'Backyards & Patios',
    color: 'from-[#1A1A1A] to-[#3D6B4F]'
  }, {
    name: 'The Sunset Green',
    mood: 'Scenic, Dramatic, Evening-focused',
    setting: 'Rooftops & Vistas',
    color: 'from-[#B8965A] to-[#1B3A2D]'
  }, {
    name: 'The Resort Green',
    mood: 'Aspirational, High-traffic, Durable',
    setting: 'Hotels & Hospitality',
    color: 'from-[#C4A97D] to-[#FAF8F3]'
  }, {
    name: 'The Challenge Green',
    mood: 'Competitive, Fun, Dynamic',
    setting: 'Clubs & Communities',
    color: 'from-[#2A2A2A] to-[#1B3A2D]'
  }, {
    name: 'The Wedding Green',
    mood: 'Elegant, Photogenic, Memorable',
    setting: 'Venues & Estates',
    color: 'from-[#FAF8F3] to-[#D4B87A]'
  }, {
    name: 'The Night Green',
    mood: 'Illuminated, Vibe-driven, Modern',
    setting: 'Urban & Hospitality',
    color: 'from-[#000000] to-[#1B3A2D]'
  }, {
    name: 'The Brand Green',
    mood: 'Custom, Bold, Impactful',
    setting: 'Activations & Events',
    color: 'from-[#B8965A] to-[#1A1A1A]'
  }];
  return <div className="w-full pt-24 bg-brand-cream-light" data-id="element-911">
      <section className="py-24 text-center max-w-4xl mx-auto px-6" data-id="element-912">
        <SectionHeading eyebrow="Our Portfolio" title="Signature Concepts" subtitle="A curated collection of design approaches, each tailored to a specific environment, user experience, and aesthetic goal." align="center" data-id="element-913" />
      </section>

      <section className="pb-32 px-6 max-w-7xl mx-auto" data-id="element-914">
        <div className="space-y-24" data-id="element-915">
          {concepts.map((concept, i) => <ScrollReveal key={concept.name} delay={0.1} data-id="element-916">
              <div className={`flex flex-col ${i % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-12 items-center`} data-id="element-917">
                <div className="w-full md:w-1/2 aspect-[4/3] rounded-sm overflow-hidden relative" data-id="element-918">
                  <div className={`absolute inset-0 bg-gradient-to-tr ${concept.color} opacity-90`} data-id="element-919" />
                  <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+')] opacity-30 mix-blend-overlay" data-id="element-920" />
                </div>
                <div className="w-full md:w-1/2" data-id="element-921">
                  <h2 className="text-4xl font-heading text-brand-green-deep mb-4" data-id="element-922">
                    {concept.name}
                  </h2>
                  <div className="space-y-4 font-body text-brand-stone mb-8" data-id="element-923">
                    <p data-id="element-924">
                      <strong className="text-brand-charcoal" data-id="element-925">Mood:</strong>{' '}
                      {concept.mood}
                    </p>
                    <p data-id="element-926">
                      <strong className="text-brand-charcoal" data-id="element-927">
                        Ideal Setting:
                      </strong>{' '}
                      {concept.setting}
                    </p>
                  </div>
                  <p className="font-body text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-928">
                    Designed specifically for {concept.setting.toLowerCase()},
                    this concept focuses on creating a{' '}
                    {concept.mood.toLowerCase()} experience that perfectly
                    matches the environment and user intent.
                  </p>
                </div>
              </div>
            </ScrollReveal>)}
        </div>
      </section>
    </div>;
}